<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" label="Tên chức năng" placeholder="Nhập tên chức năng" v-model="permisionInfo.functionName"
                                  v-validate="'required'" name="namePermision"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermision') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" label="Tên hiển thị" placeholder="Nhập tên hiển thị" v-model="permisionInfo.functionAlias"
                                v-validate="'required'"
                                name="namePermisionAlias"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermisionAlias') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" label="Màn hình" placeholder="Nhập màn hình" v-model="permisionInfo.groupPermission"
                                v-validate="'required'"
                                name="namePermisionGroup"/>
                        <span class="text-danger text-sm">{{ errors.first('namePermisionGroup') }}</span>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <vs-input class="w-full" label="Sắp xếp" v-model="permisionInfo.displayOrder"
                                name="displayOrder"/>
                    </div>
                </div>

                 <div class="vx-row mt-4">
                    <div class="vx-col md:w-1/2 w-full">
                        <vs-input class="w-full" label="Api Path" placeholder="Api Path" v-model="permisionInfo.functionApiPrefix"
                                  v-validate="'required'" name="apiPath"/>
                        <span class="text-danger text-sm">{{ errors.first('apiPath') }}</span>
                    </div>

                     <div class="vx-col md:w-1/2 w-full">
                        <vs-input class="w-full" label="Screen Path" placeholder="Screen Path" v-model="permisionInfo.functionScreenPrefix"
                                  v-validate="'required'" name="screenPath"/>
                        <span class="text-danger text-sm">{{ errors.first('screenPath') }}</span>
                    </div>
                </div>

                <br>
                <br>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges"
                                       :disabled="!validateForm">{{
                                    `${isUpdate ? 'Cập nhật' : 'Tạo mới'}`
                                }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="leaveList">Quay lại
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import utils from "../../../../components/utils";
// import moment from 'moment';
import 'quill/dist/quill.snow.css';

export default {
    components: {
        utils,
    },
    data() {
        return {
            isUpdate: false,
            permisionInfo: {},
            permisionId: 0,
        }
    },
    created() {
        this.initScreen();
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.permisionInfo = {
            functionName: '',
            functionAlias: '',
            groupPermission: '',
            functionApiPrefix: '',
            functionScreenPrefix: '',
            displayOrder: 0,
            organizationId: 0,
        };
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },
    methods: {
        successUpload() {
            this.$vs.notify({
                color: 'success',
                title: 'Upload Success',
                text: 'Lorem ipsum dolor sit amet, consectetur'
            })
        },
        onOptionClick({option, addTag}) {
            addTag(option)
            this.search = ''
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        async initScreen() {
            try {
                if(!this.$route.query.permisionId) {
                    this.isUpdate = false;
                    return
                }
                this.$vs.loading();
                const res = await this.$oauth.get(`permission-function-global/find-by-id/${this.$route.query.permisionId}`)
                let permisionDetail = res.data;
                this.permisionInfo.functionName = permisionDetail.functionName;
                this.permisionInfo.functionAlias = permisionDetail.functionAlias;
                this.permisionInfo.groupPermission = permisionDetail.groupPermission;
                this.permisionInfo.functionApiPrefix = permisionDetail.functionApiPrefix;
                this.permisionInfo.functionScreenPrefix = permisionDetail.functionScreenPrefix;
                this.permisionInfo.displayOrder = permisionDetail.displayOrder;
                this.permisionId = permisionDetail.id;
                this.isUpdate = true;
                this.$vs.loading.close();
            }catch(err) {
                this.isUpdate = false;
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            }
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;

                let currentUser = JSON.parse(localStorage.getItem('userInfo') || '{}')

                let url = `/permission-function-global/create`;

                let params = {...this.permisionInfo, organizationId: currentUser.organization.id}

                if(this.isUpdate) {
                    url = `permission-function-global/update/${this.permisionId}`
                    params = {...params, id: this.permisionId}
                }

                this.$vs.loading();
                this.$oauth.post(url, params).then(() => {
                    this.$vs.loading.close();
                    this.leaveList();
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },
        leaveList() {
            this.$router.push(`/user/manage-permision`).catch(() => {
            })
        }
    },
}
</script>

<style scoped>
.input-content{
    height: 200px !important;
}
</style>
